import React from 'react';

import { Icon } from '@common/components';

const statusIconMap = {
  rejected: { icon: 'triangleExclamation', color: 'coral' },
  approved: { icon: 'circleCheck', color: 'grass' },
} as const;

type StatusIconKey = keyof typeof statusIconMap;

export const AttachmentSelectorStatusIcon = ({
  status,
}: {
  status: string;
}) => {
  const isValidStatus = (s: string): s is StatusIconKey => s in statusIconMap;

  if (!isValidStatus(status)) return null;

  const statusConfig = statusIconMap[status];
  return <Icon icon={statusConfig.icon} color={statusConfig.color} />;
};
